import { type BridgeData } from '@databases/database-state/state/bridge-data';
import { perf } from '@databases/logs/performance';

import { currentUserState } from '@canvas/canvas-state/user';
import { setIdentity } from '@canvas/connection/identity';
import { type CanvasIdentity, IdentityKind } from '@canvas/model/identity';

export const initializeUserState = ({ identity }: Pick<BridgeData, 'identity'>) => {
  perf.timeLog('app-initialization', 'user-state');

  currentUserState.identity = {
    ...identity,
    // TODO - Profile information is passed in from CFE via a data attribute
    // We'll need to add `displayName` to the bridge data on the CFE so we can
    // remove this
    displayName: identity.nickname,
    type: IdentityKind.CanvasId,
  };
  currentUserState.status = 'succeeded';

  setIdentity(currentUserState.identity as CanvasIdentity);
};
